var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowModal)?_c('iframe',{staticClass:"fixed top-0 left-0 bottom-0 right-0 w-screen h-screen overflow-y-hidden z-50",attrs:{"title":"","src":_vm.srcIframe}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }